var modSliderText = function(){
    var scope = ".js-mod-slider-text";
    ui.ready(
        scope,
        function($mod){
            new Swiper($mod.find(scope + '__slider').get(0), {
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                // AutoPlay
                autoplay: {
                    delay: 7000,
                    pauseOnMouseEnter: true,
                },
                speed: 1000,
                watchSlidesProgress: true,
                watchSlidesVisibility: true,
                // Loop
                loop: true,
            });

        }

    );

}();